import React, { useState } from "react";
import Papa from "papaparse";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [chunks, setChunks] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [lastClickedIndex, setLastClickedIndex] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      setError(null);
      Papa.parse(file, {
        header: true,
        complete: (result) => {
          try {
            if (result.data.length === 0) {
              throw new Error("CSV file appears to be empty");
            }
            // Use the first column, whatever it's named
            const firstColumnName = Object.keys(result.data[0])[0];
            const ids = result.data.map((row) => row[firstColumnName]).filter(Boolean);
            if (ids.length === 0) {
              throw new Error("No valid values found in the first column");
            }
            const chunkedIds = chunkArray(ids, 15);
            setChunks(chunkedIds);
          } catch (err) {
            setError(err.message);
            setChunks([]);
          } finally {
            setIsLoading(false);
          }
        },
        error: (error) => {
          setError("Error parsing CSV file: " + error.message);
          setChunks([]);
          setIsLoading(false);
        },
      });
    }
  };

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      const formattedChunk = chunk.map((id, index) => {
        return index === chunk.length - 1 ? id : id + ',';
      }).join(' ');
      chunks.push(formattedChunk);
    }
    return chunks;
  };

  const handleCopyClick = (text, index) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setLastClickedIndex(index);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
        setError('Failed to copy to clipboard');
      });
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card shadow-sm">
            <div className="card-body">
              <h1 className="card-title text-center mb-4">
                BoB report to list
              </h1>
              <p className="text-center mb-4">
                Export this <a href="https://personio.lightning.force.com/lightning/r/Report/00ObG000007wx8bUAA/view">report</a> as .csv and upload it here
              </p>
              <div className="text-start mb-4">
                <ol>
                  <li>Create new contact list</li>
                  <li>Add 10 filters with "Account ID 18 equals chunk"</li>
                  <li>Add filter logic "1 OR 2 OR 3 OR 4 OR 5 OR 6 OR 7 OR 8 OR 9 OR 10"</li>
                </ol>
              </div>
              
              <div className="mb-4">
                <div className="input-group">
                  <input 
                    type="file" 
                    accept=".csv" 
                    onChange={handleFileUpload}
                    className="form-control" 
                  />
                </div>
              </div>

              {isLoading && (
                <div className="alert alert-info">
                  Loading...
                </div>
              )}
              
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}

              {chunks.length > 0 && (
                <div>
                  <h2 className="h4 mb-3">Chunks of 15 IDs:</h2>
                  {chunks.map((chunk, index) => (
                    <div key={index} className="card mb-3">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <strong>Chunk {index + 1}</strong>
                        <button 
                          onClick={() => handleCopyClick(chunk, index)}
                          className={`btn ${lastClickedIndex === index ? 'btn-primary' : 'btn-secondary'}`}
                        >
                          Copy
                        </button>
                      </div>
                      <div className="card-body">
                        <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                          {chunk}
                        </pre>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
